"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHECKBOX = void 0;
const vue_1 = __importDefault(require("vue"));
const types_1 = require("./types");
const cell_editor_1 = require("./cell-editor");
const cell_formatter_1 = require("./cell-formatter");
const CHECKBOX_FORMATTER_CONFIG = types_1.BASE_CONFIG.extend({});
const CHECKBOX_EDITOR_CONFIG = types_1.BASE_CONFIG.extend({});
exports.CHECKBOX = {
    name: 'checkbox',
    textAlign: 'center',
    formatter: {
        schema: CHECKBOX_FORMATTER_CONFIG,
        createComponent(config) {
            return {
                textAlign: 'center',
                component: {
                    name: 'CheckBoxFormatter',
                    mixins: [cell_formatter_1.CellFormatter],
                    ...vue_1.default.compile(`<b-form-checkbox
                v-model="value"
                :size="col.size"
                disabled
            ></b-form-checkbox>`)
                }
            };
        }
    },
    editor: {
        textAlign: 'center',
        schema: CHECKBOX_EDITOR_CONFIG,
        createComponent(config) {
            return {
                textAlign: 'center',
                component: {
                    name: 'CheckBoxEditor',
                    mixins: [cell_editor_1.CellEditor],
                    ...vue_1.default.compile(`<b-form-checkbox
              v-model="currentValue"
              :id="col.field"
              :name="col.name"
              :form="formId"
              :tabindex="col.effectiveTabindex"
              :size="col.size"
              :state="validationState"
              :disabled="isDisabled"
              @change="onChange($event)"
            ></b-form-checkbox>`)
                }
            };
        }
    }
};
//# sourceMappingURL=checkbox.js.map